import { resourceHost } from '@/environment'
import request from '@/modules/base/util/request'
import getCollaborationRequestHeader from '@/modules/document/_helpers/getCollaborationRequestHeader'

export const TagService = {
  fetchTags: (category) => {
    return request(`${resourceHost}tags?category=${category}`, {
      auth: true,
      isConcurrent: true,
      method: 'GET',
      headers: getCollaborationRequestHeader(),
    })
  },

  postTags: (labels) => {
    return request(`${resourceHost}tags`, {
      auth: true,
      isConcurrent: true,
      method: 'POST',
      data: { labels },
      headers: getCollaborationRequestHeader(),
    })
  },
}
